import React from 'react';

export const RaisedHandIconAsset = (): JSX.Element => (
    <svg width="16" height="16" viewBox="0 0 16 16" style={{lineHeight: '16px'}} fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_3439_11242)">
            <path d="M8.66747 16C6.49413 16 4.5408 14.6733 3.73413 12.6533L1.71413 7.58C1.50747 7.05333 2.0008 6.52667 2.5408 6.7L3.06747 6.87333C3.4408 6.99333 3.74747 7.28 3.89413 7.64667L4.83413 10H5.33413V2.16667C5.33413 1.70667 5.70747 1.33333 6.16747 1.33333C6.62747 1.33333 7.0008 1.70667 7.0008 2.16667V8H7.66747V0.833333C7.66747 0.373333 8.0408 0 8.5008 0C8.9608 0 9.33413 0.373333 9.33413 0.833333V8H10.0008V1.83333C10.0008 1.37333 10.3741 1 10.8341 1C11.2941 1 11.6675 1.37333 11.6675 1.83333V8H12.3341V3.83333C12.3341 3.37333 12.7075 3 13.1675 3C13.6275 3 14.0008 3.37333 14.0008 3.83333V10.6667C14.0008 13.6133 11.6141 16 8.66747 16Z" fill="#F2C601" />
        </g>
        <defs>
            <clipPath id="clip0_3439_11242">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
